

// TODO: review inclusion in metadata with static key ncaInput (what other keys are there if any? Can they share a status)
export enum AplosNcaInputStatus {

    Approved = "approved",
    ConversionRequired = "conversion-required"

}